<template>

    <div class="container register-page">
        <div class="row">
            <div class="offset-lg-3 col-lg-6 bg-ss-gray">
                <h2>{{ lang('all.account_aanmaken') }}</h2>

                <p>{{ lang('all.deze_webshop_is_uitsluitend_bedoeld_voor_zakelijke') }}</p>

                <text-input
                    label=""
                    type="text"
                    :placeholder="lang('all.bedrijfsnaam')"
                    v-model="form.name"
                    :errors="errors.name"
                    @focus="removeErrors('name')"
                ></text-input>

                <text-input
                    label=""
                    type="email"
                    placeholder="E-mailadres"
                    v-model="form.email"
                    :errors="errors.email"
                    @focus="removeErrors('email')"
                ></text-input>

                <text-input
                    label=""
                    type="text"
                    :placeholder="lang('all.btw_nummer')"
                    v-model="form.taxnumber"
                    :errors="errors.taxnumber"
                    @focus="removeErrors('taxnumber')"
                    :description="noTaxNumberClientDescription"
                ></text-input>

                <text-input
                    label=""
                    type="password"
                    :placeholder="lang('all.gewenst_wachtwoord')"
                    v-model="form.password"
                    :errors="errors.password"
                    @focus="removeErrors('password')"
                    @blur="checkIfPasswordsMatch"
                ></text-input>

                <text-input
                    label=""
                    type="password"
                    :placeholder="lang('all.wachtwoord_bevestigen')"
                    v-model="form.password_confirmation"
                    @focus="removeErrors('password')"
                    @blur="checkIfPasswordsMatch"
                ></text-input>

                <checkbox-input
                    v-model="form.accepttac"
                    class="mb-4"
                    :errors="errors.accepttac"
                >
                    {{ lang('all.ik_ga_akkoord_met_de') }} <inertia-link :href="route('content.index', {any:'algemene-voorwaarden'})">{{ lang('all.algemene_voorwaarden2') }}</inertia-link>
                </checkbox-input>

                <blockquote class="noquotes mb-4">{{ lang('all.login_page_confirmation_mail') }}</blockquote>

                <div>
                    <button
                        class="btn btn-primary float-right"
                        :disabled="!canRegister"
                        @click="register"
                    >
                        {{ lang('all.account_aanmaken') }}
                    </button>

                    <inertia-link
                        class="float-left pt-2"
                        :href="route('guest.login')"
                    >
                        {{ lang('all.al_een_account') }}
                    </inertia-link>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import TextInput from "../../Common/TextInput";
import CheckboxInput from "../../Common/CheckboxInput";

export default {

    components: {
        TextInput,
        CheckboxInput,
    },

    computed: {
        canRegister() {
            return this.posting === false &&
                this.form.email !== '' &&
                this.form.password !== '' &&
                this.form.password === this.form.password_confirmation &&
                this.form.taxnumber !== '' &&
                this.form.accepttac === true;
        },

        errors() {
            return this.foundErrors;
        },

        noTaxNumberClientDescription() {
            return this.lang('all.zakelijke_gebruiker_zonder_btw_nummer') + ' <a href="' + this.route('content.index', {any: 'contact'}) + '">' + this.lang('all.neem_contact_met_ons_op') + '</a>';
        },

        propErrors() {
            return this.$page.props.errors;
        }
    },

    data() {
        return {
            form:{
                name:'',
                email:'',
                password:'',
                password_confirmation:'',
                taxnumber:'',
                cocnumber:'',
                accepttac:false,
            },
            foundErrors:{},
            posting:false,
        }
    },

    layout:Layout,

    metaInfo() {
        return {
            title: 'Registreren',
            meta: [
                {vmid:'keywords',name:'keywords',content:'registreren,registratieformulier'},
                {vmid:'description',name:'description',content:'Maak een account aan op onze website'},
            ],
        }
    },

    methods: {
        checkIfPasswordsMatch() {
            if (this.form.password === '') {
                this.foundErrors.password = ['Er is geen wachtwoord ingevoerd'];
            }
            if (this.form.password !== this.form.password_confirmation) {
                console.log('aaa');
                this.foundErrors.password = ['De ingevoerde wachtwoorden komen niet overeen'];
            }
        },

        register() {
            if (!this.canRegister) {
                return;
            }
            this.posting = true;

            this.$inertia.post(this.route('guest.register.attempt'), this.form, {
                onFinish: () => this.posting = false
            })
        },

        removeErrors(field) {
            let err = JSON.parse(JSON.stringify(this.foundErrors));

            if (err[field]) {
                delete err[field];
            }

            this.foundErrors = err;
        },
    },

    name:'GuestRegister',

    watch: {
        propErrors: function (newval) {
            this.foundErrors = JSON.parse(JSON.stringify(newval));
        },
    },

}

</script>
